export const statesData = [
  {
    name: "Andhra Pradesh",
    cities: ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"]
  },
  {
    name: "Arunachal Pradesh",
    cities: ["Itanagar", "Tawang", "Ziro", "Pasighat"]
  },
  {
    name: "Assam",
    cities: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat"]
  },
  {
    name: "Bihar",
    cities: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur"]
  },
  {
    name: "Chhattisgarh",
    cities: ["Raipur", "Bhilai", "Bilaspur", "Korba"]
  },
  {
    name: "Goa",
    cities: ["Panaji", "Margao", "Vasco da Gama"]
  },
  {
    name: "Gujarat",
    cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot"]
  },
  {
    name: "Haryana",
    cities: ["Gurgaon", "Faridabad", "Panipat", "Ambala", "Karnal", "Hisar", "Rohtak"]
  },
  {
    name: "Himachal Pradesh",
    cities: ["Shimla", "Manali", "Dharamshala", "Solan"]
  },
  {
    name: "Jharkhand",
    cities: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro"]
  },
  {
    name: "Karnataka",
    cities: ["Bangalore", "Mysore", "Mangalore", "Hubli"]
  },
  {
    name: "Kerala",
    cities: ["Kochi", "Trivandrum", "Kozhikode", "Thrissur"]
  },
  {
    name: "Madhya Pradesh",
    cities: ["Indore", "Bhopal", "Gwalior", "Jabalpur"]
  },
  {
    name: "Maharashtra",
    cities: ["Mumbai", "Pune", "Nagpur", "Nashik"]
  },
  {
    name: "Manipur",
    cities: ["Imphal", "Thoubal", "Churachandpur"]
  },
  {
    name: "Meghalaya",
    cities: ["Shillong", "Tura"]
  },
  {
    name: "Mizoram",
    cities: ["Aizawl", "Lunglei"]
  },
  {
    name: "Nagaland",
    cities: ["Kohima", "Dimapur"]
  },
  {
    name: "Odisha",
    cities: ["Bhubaneswar", "Cuttack", "Rourkela", "Puri"]
  },
  {
    name: "Punjab",
    cities: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala"]
  },
  {
    name: "Rajasthan",
    cities: ["Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer"]
  },
  {
    name: "Sikkim",
    cities: ["Gangtok", "Namchi"]
  },
  {
    name: "Tamil Nadu",
    cities: ["Chennai", "Coimbatore", "Madurai", "Salem"]
  },
  {
    name: "Telangana",
    cities: ["Hyderabad", "Warangal", "Karimnagar"]
  },
  {
    name: "Tripura",
    cities: ["Agartala"]
  },
  {
    name: "Uttar Pradesh",
    cities: ["Lucknow", "Kanpur", "Noida", "Ghaziabad", "Varanasi", "Agra"]
  },
  {
    name: "Uttarakhand",
    cities: ["Dehradun", "Haridwar", "Haldwani"]
  },
  {
    name: "West Bengal",
    cities: ["Kolkata", "Howrah", "Durgapur", "Siliguri"]
  },

  // ✅ UNION TERRITORIES
  {
    name: "Delhi",
    cities: ["New Delhi", "Dwarka", "Rohini"]
  },
  {
    name: "Jammu and Kashmir",
    cities: ["Srinagar", "Jammu"]
  },
  {
    name: "Ladakh",
    cities: ["Leh", "Kargil"]
  },
  {
    name: "Chandigarh",
    cities: ["Chandigarh"]
  },
  {
    name: "Puducherry",
    cities: ["Puducherry"]
  },
  {
    name: "Andaman and Nicobar Islands",
    cities: ["Port Blair"]
  },
  {
    name: "Dadra and Nagar Haveli and Daman and Diu",
    cities: ["Daman", "Diu", "Silvassa"]
  },
  {
    name: "Lakshadweep",
    cities: ["Kavaratti"]
  }
];